import { PAYMENT_UPDATE, PAYMENT_UPDATE_DONE, PAYMENT_UPDATE_ERROR, PAYMENT_UPDATE_RESET } from './actionTypes';
export const paymentUpdate = (data) => ({
    type: PAYMENT_UPDATE,
    data
});
export const paymentUpdateDone = () => ({
    type: PAYMENT_UPDATE_DONE
});
export const paymentUpdateError = (data) => ({
    type: PAYMENT_UPDATE_ERROR,
    errorMessage: data
});
export const paymentUpdateReset = () => ({
    type: PAYMENT_UPDATE_RESET
});
//# sourceMappingURL=actionCreators.js.map